import { render, staticRenderFns } from "./CreatePtMappingBtn.vue?vue&type=template&id=fb81ed34&"
import script from "./CreatePtMappingBtn.vue?vue&type=script&lang=js&"
export * from "./CreatePtMappingBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports